module.exports = __webpack_public_path__ + "assets/img/img_coin.5c75b69f.svg";